const GRID_SIZE = 10;
export {
  GRID_SIZE
};
//# sourceMappingURL=constants.js.map
